import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import UILogo from 'UIComponents/image/UILogo';
import UIMedia from 'UIComponents/layout/UIMedia';
import UIMediaBody from 'UIComponents/layout/UIMediaBody';
import UIMediaLeft from 'UIComponents/layout/UIMediaLeft';
import UITruncateString from 'UIComponents/text/UITruncateString';
import { NETWORK_LOGO } from '../../../../constants/ads';
export default function AdCampaignName({
  campaign
}) {
  const networkLogo = NETWORK_LOGO[campaign.adNetwork.toUpperCase()];
  return /*#__PURE__*/_jsxs(UIMedia, {
    className: "m-bottom-2",
    children: [/*#__PURE__*/_jsx(UIMediaLeft, {
      children: campaign.adNetwork && /*#__PURE__*/_jsx(UILogo, {
        "data-test-id": "ad-campaign-logo",
        name: networkLogo,
        width: 18
      })
    }), /*#__PURE__*/_jsx(UIMediaBody, {
      children: /*#__PURE__*/_jsx(UITruncateString, {
        "data-test-id": "ad-campaign-name",
        children: campaign.name
      })
    })]
  });
}